import React, { useState } from 'react';
import { Button } from '@mui/material';
import AppleIcon from '@mui/icons-material/Apple';
import { signInWithApple } from '../services/appleAuth';

interface AppleSignInButtonProps {
  fullWidth?: boolean;
  variant?: 'contained' | 'outlined' | 'text';
  disabled?: boolean;
  onSuccess?: (idToken: string) => void;
  onError?: (error: string) => void;
}

const AppleSignInButton: React.FC<AppleSignInButtonProps> = ({
  fullWidth = true,
  variant = 'outlined',
  disabled = false,
  onSuccess,
  onError,
}) => {
  const [loading, setLoading] = useState(false);

  const handleAppleSignIn = async () => {
    setLoading(true);
    try {
      const response = await signInWithApple();
      const { idToken } = response;
      if (idToken && onSuccess) {
        onSuccess(idToken);
      }
    } catch (error: any) {
      console.error('Apple sign-in failed:', error);
      if (onError) {
        onError(error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      fullWidth={fullWidth}
      variant={variant}
      onClick={handleAppleSignIn}
      disabled={disabled || loading}
      sx={{
        textTransform: 'none',
        borderColor: '#F57C00',
        backgroundColor: '#FFF3E0',
        color: '#000',
        '&:hover': {
          backgroundColor: 'rgba(0,0,0,0.08)',
          borderColor: '#F57C00',
        },
        height: '40px',
        fontSize: '14px',
        fontWeight: 500,
        mb: 1,
      }}
      // startIcon={<AppleIcon />}
    >
      {loading ? 'Signing in...' : 'Continue with Apple'}
    </Button>
  );
};

export default AppleSignInButton; 